import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, Mail } from 'lucide-react';

const LOGO_URL = "/images/area-logo.png";

export function Footer() {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12">
          <div className="lg:col-span-2">
            <img src={LOGO_URL} alt="AREA" className="h-12 w-auto mb-6 brightness-0 invert"/>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Uniting real estate professionals nationwide through collaboration, 
              advocacy, and shared opportunity.
            </p>
            <div className="space-y-3 text-sm text-slate-400">
              <h4 className="font-semibold text-white mb-4">Contact Us</h4>
              <a href="mailto:hello@americanrea.com" className="flex items-center gap-2 hover:text-white">
                <Mail className="w-4 h-4" /> hello@americanrea.com
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">AREA</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/community" className="hover:text-white">Community</Link></li>
              <li><Link to="/register" className="hover:text-white">Join AREA</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Resources</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/faq" className="hover:text-white">FAQs</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-400">
            © {new Date().getFullYear()} American Real Estate Alliance. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="p-2 rounded-full bg-slate-800 text-slate-400 hover:bg-[#3D4F7A] hover:text-white" aria-label="Facebook">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="#" className="p-2 rounded-full bg-slate-800 text-slate-400 hover:bg-[#3D4F7A] hover:text-white" aria-label="Twitter">
              <Twitter className="w-4 h-4" />
            </a>
            <a href="#" className="p-2 rounded-full bg-slate-800 text-slate-400 hover:bg-[#3D4F7A] hover:text-white" aria-label="LinkedIn">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href="#" className="p-2 rounded-full bg-slate-800 text-slate-400 hover:bg-[#3D4F7A] hover:text-white" aria-label="Instagram">
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
